/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import type { GatsbyBrowser } from 'gatsby'

import './src/styles/globals.css'
import './src/styles/markdown.css'

import { countRouteChange, startGoatCounter } from './src/lib/goatcounter'

// Page views go to GoatCounter; see src/lib/goatcounter.ts. The landing page is
// counted when the script loads, so only in-site moves are counted here.
export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => startGoatCounter()

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  if (prevLocation) countRouteChange(location, prevLocation)
}
